import _ from "lodash"

export function humanFileSize(bytes, si) {
  var thresh = si ? 1000 : 1024
  if (Math.abs(bytes) < thresh) {
    return bytes + " B"
  }
  var units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
  var u = -1
  do {
    bytes /= thresh
    ++u
  } while (Math.abs(bytes) >= thresh && u < units.length - 1)
  return bytes.toFixed(1) + " " + units[u]
}

export function isAddressComponentsEmpty(addressComponents) {
  let address = addressComponents
  let checkParameters = ["street_number", "route", "locality", "administrative_area_level_1", "postal_code", "country"]
  let isAddressEmpty = true
  checkParameters.forEach(e => {
    if (address[e].length > 0) isAddressEmpty = false
  })
  return isAddressEmpty
}

// export function mapStore(map) {
//   let computed = {}
//   Object.keys(map).forEach(name => {
//     let rule = map[name]
//     computed[name] = {
//       get() {
//         return this.$store.getters[`${rule.getter}`]
//       },
//       set(v) {
//         this.$store.dispatch(`${rule.action}`, v)
//       }
//     }
//   })
//   return computed
// }

export function mapStore(definition) {
  const computed = {}

  if (Array.isArray(definition)) {
    // If array, assume each key is the name of a state and mutation
    definition.forEach(stateName => {
      computed[stateName] = {
        get() {
          return this.$store.state[stateName]
        },
        set(value) {
          this.$store.commit(stateName, value)
        }
      }
    })
  } else if (_.isPlainObject(definition)) {
    // If Object, each paramater can sepcify the mapping of states and mutations
    Object.keys(definition).forEach(name => {
      let rule = definition[name]
      computed[name] = {
        get() {
          return this.$store.getters[`${rule.getter}`]
        },
        set(v) {
          this.$store.dispatch(`${rule.action}`, v)
        }
      }
    })
  }

  return computed
}
